import React from 'react';
import LegalLayout, {
  LegalSection,
  LegalParagraph,
  LegalList,
  LegalNote
} from './LegalLayout';

const PrivacyPolicy = () => (
  <LegalLayout
    title="Privacy Policy"
    effectiveDate="Effective from 1 June 2026"
    pageTestId="privacy-policy-page"
  >
    <LegalParagraph>
      Read Right Academy (&ldquo;we&rdquo;, &ldquo;our&rdquo;, &ldquo;us&rdquo;)
      respects the privacy of every parent, child, teacher, and visitor who
      interacts with our website and programmes. This Privacy Policy explains
      what information we collect, how we use it, and the choices you have.
    </LegalParagraph>

    <LegalSection heading="1. Information We Collect">
      <LegalParagraph>We may collect the following information:</LegalParagraph>
      <LegalList
        items={[
          'Contact details you submit through the website or WhatsApp — name, email, phone number, your child\'s age range.',
          'Enquiry and trial-class details — programme of interest, child\'s reading needs, and any context you share with us.',
          'Free guide subscribers — name and email submitted when you download our 5-Day Phonics Starter Guide.',
          'Basic website analytics — anonymised page-view and device data used to improve the website experience.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="2. How We Use Your Information">
      <LegalParagraph>
        We use the information you share to:
      </LegalParagraph>
      <LegalList
        items={[
          'Respond to enquiries and arrange free trial classes',
          'Recommend programmes that suit your child or learning needs',
          'Send the free guide and follow-up parent tips, if requested',
          'Provide ongoing communication about classes, schedules, and feedback',
          'Improve our website, programmes, and parent communication'
        ]}
      />
    </LegalSection>

    <LegalSection heading="3. How We Store and Protect Information">
      <LegalParagraph>
        Your information is stored securely and accessed only by Read Right
        Academy team members who need it to respond to you or deliver our
        programmes. We do not sell, rent, or trade your personal information
        with third parties.
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="4. Children's Information">
      <LegalNote tone="safe">
        We treat any information you share about your child with extra care.
        We only collect what is necessary to recommend suitable lessons (such
        as age range and reading readiness). We never share or publish your
        child&apos;s personal information.
      </LegalNote>
    </LegalSection>

    <LegalSection heading="5. Your Choices and Rights">
      <LegalList
        items={[
          'You can request a copy of the information we hold about you at any time.',
          'You can ask us to update or delete your information.',
          'You can unsubscribe from our free guide emails using the unsubscribe link in any message.'
        ]}
      />
      <LegalParagraph>
        To exercise any of these rights, email{' '}
        <a
          href="mailto:teacherkalah@gmail.com"
          className="text-[#3B4BA0] hover:underline"
        >
          teacherkalah@gmail.com
        </a>
        .
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="6. Cookies and Analytics">
      <LegalParagraph>
        Our website may use cookies and analytics tools (such as anonymised
        page-view tracking) to understand how visitors use the site. You can
        disable cookies in your browser settings at any time.
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="7. Changes to This Policy">
      <LegalParagraph>
        We may update this Privacy Policy from time to time. Any changes will
        be posted on this page with a new effective date.
      </LegalParagraph>
    </LegalSection>
  </LegalLayout>
);

export default PrivacyPolicy;
